import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { createTheme, Popper, ThemeProvider } from '@mui/material';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

function InputWithAutocomplete({
  entity,
  error,
  theme,
  autoCompleteStyles,
  disabled,
  autocompleteValues,
  fieldValue,
  changeHandler,
  placeholder,
  disableLegend = false,
  sx = {},
  clearSuggestions = () => {}
}) {
  return (
    <ThemeProvider theme={theme ?? createTheme({})}>
      <Autocomplete
        freeSolo
        loading
        disableClearable
        // eslint-disable-next-line react/no-unstable-nested-components
        PopperComponent={(popperProps) => <Popper {...popperProps} placement="top-start" />}
        loadingText={`Please type first 3 letters of your ${entity}`}
        isOptionEqualToValue={async (option, value) => (await option.label) === value}
        onBlur={(e) => {
          const match = autocompleteValues.find((x) => x.label === e.target.value);
          clearSuggestions(entity);
          if (match) return;
          changeHandler({ entity, value: '' });
        }}
        onFocus={(e) => changeHandler({ entity, value: e.target.value }, false)}
        sx={{
          ...sx,
          ...autoCompleteStyles,
          ...(disableLegend && {
            legend: {
              display: 'none'
            },
            fieldset: {
              top: 0
            }
          }),
          '& .MuiAutocomplete-root': {
            p: 0
          },
          '& .MuiInputBase-root': {
            p: 0,
            borderRadius: '8px'
          },
          '& .MuiInputBase-input': {
            p: 0
          },
          '& .MuiOutlinedInput-root': {
            p: 0
          },
          '& .MuiAutocomplete-inputRoot': {
            p: '5px'
          },
          '& .MuiAutocomplete-input': {
            p: 0
          }
        }}
        onInput={(e) => {
          changeHandler({ entity, value: e.target.value });
        }}
        onChange={(e) => {
          setTimeout(
            () => changeHandler({ entity, value: e?.code === 'Enter' ? e.target.value : e.target.outerText }),
            0
          );
        }}
        value={fieldValue}
        disablePortal
        disabled={disabled}
        id="country"
        options={autocompleteValues}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            type="text"
            placeholder={placeholder}
            InputProps={{ ...params.InputProps, style: { fontSize: `14px` } }}
          />
        )}
      />
      {error && <ValidationErrorLabel message={error} />}
    </ThemeProvider>
  );
}

export default InputWithAutocomplete;
